export const CREATE_QUOTATION = "CREATE_QUOTATION";
export const ACCEPT_QUOTATION = "ACCEPT_QUOTATION";
export const SEND_QUOTATION = "SEND_QUOTATION";
export const UPLOAD_TICKET = "UPLOAD_TICKET";
export const DELETE_TICKET = "DELETE_TICKET";
export const SEND_TICKET = "SEND_TICKET";
